import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useFormState, useForm } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import QCXAutocompleteSelect from '../../../shared-components/autocomplete-select/QCXAutocompleteSelect' // lista suspensa

export default function OrgaosAnuentesField ({
    metadado, 
    orgaosAnuentes,
    isConsult,
    basePath="",
    ...restProps

}) {

    const [obrigatorio, setObrigatorio] = useState(false);
    const [listValores, setListValores] = useState([]);
    const [defaultValue, setDefaultValue] = useState('');


    const filterOptions = createFilterOptions({
        stringify: (item) => `${item.codigo} - ${item.value}`,
    });


    useEffect(() => {
   
      if (orgaosAnuentes) {
        setListValores([...orgaosAnuentes].map(el => ({
            id: el.code,
            value: `${el.description}`,
        })))

        setDefaultValue({ id: null, value: '' });
      }

    }, [orgaosAnuentes])


    return (
        <>
          <QCXAutocompleteSelect
            label="Orgãos Anuentes"
            id="atributosAdicionais.lpcoForm.orgaoAnuenteCode"
            name="atributosAdicionais.lpcoForm.orgaoAnuenteCode"
            options={listValores}
            filterOptions={filterOptions}
            defaultValue={defaultValue}
            getOptionLabel={(item) => (
                item.value ? item.value : ''
            )}
            required={obrigatorio}
            isConsult={isConsult}
            disabled={isConsult}
            {...restProps}
          />
        </>
    )
    
    

}
